import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { api, errorText } from "../lib/api";

const REASONS = ["offensive", "inappropriate", "illegal", "spam", "privacy", "other"];

export const ReportDialog = ({ open, onOpenChange, slug }) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState("");
  const [details, setDetails] = useState("");
  const [hp, setHp] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post(`/memorials/${slug}/report`, { reason, details, website: hp });
      toast.success(t("memorial.report_thanks"));
      onOpenChange(false);
      setReason("");
      setDetails("");
    } catch (err) {
      toast.error(errorText(t, err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg rounded-3xl" data-testid="report-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl font-normal">{t("memorial.report_title")}</DialogTitle>
          <DialogDescription>{t("memorial.report_lead")}</DialogDescription>
        </DialogHeader>
        <form onSubmit={send} className="space-y-4">
          <fieldset>
            <legend className="field-label">{t("memorial.report_reason")}</legend>
            <div className="grid gap-2">
              {REASONS.map((r) => (
                <label key={r} className={`flex items-center gap-3 rounded-xl border px-4 py-2.5 cursor-pointer text-sm ${reason === r ? "border-[hsl(var(--accent))] bg-[hsl(var(--secondary))]" : ""}`}>
                  <input type="radio" name="reason" value={r} checked={reason === r} onChange={() => setReason(r)} data-testid={`report-reason-${r}`} />
                  {t(`memorial.reasons.${r}`)}
                </label>
              ))}
            </div>
          </fieldset>
          <div>
            <label className="field-label" htmlFor="report-details">{t("memorial.report_details")}</label>
            <textarea id="report-details" className="field-input min-h-[90px]" maxLength={1000} value={details} onChange={(e) => setDetails(e.target.value)} data-testid="report-details-input" />
          </div>
          <input type="text" tabIndex={-1} autoComplete="off" aria-hidden="true" className="hidden" value={hp} onChange={(e) => setHp(e.target.value)} />
          <button type="submit" className="btn-primary w-full" disabled={!reason || busy} data-testid="report-submit-btn">{t("memorial.report_send")}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
